(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
  'DOMContentLoaded',
  function(){


    /* =====================================================
       EACH MEGA MENU
    ====================================================== */

    document
      .querySelectorAll('.nibbi-mega')
      .forEach(
        function(mega){


          var mainLinks =
            Array.prototype.slice.call(
              mega.querySelectorAll(
                '.nibbi-mega__main-link'
              )
            );


          var subPanels =
            Array.prototype.slice.call(
              mega.querySelectorAll(
                '.nibbi-mega__sub-panel'
              )
            );


          var showcasePanels =
            Array.prototype.slice.call(
              mega.querySelectorAll(
                '.nibbi-mega__showcase-panel'
              )
            );



          /* =================================================
             SWITCH CATEGORY ON HOVER
          ================================================= */

          function activateCategory(link){

            var target =
              link.getAttribute(
                'data-nibbi-target'
              );


            if(!target) return;


            mainLinks.forEach(
              function(item){

                item
                  .classList
                  .remove(
                    'is-active'
                  );

              }
            );


            subPanels.forEach(
              function(panel){

                panel
                  .classList
                  .remove(
                    'is-active'
                  );

              }
            );


            showcasePanels.forEach(
              function(panel){

                panel
                  .classList
                  .remove(
                    'is-active'
                  );

              }
            );


            link
              .classList
              .add(
                'is-active'
              );


            var subTarget =
              mega.querySelector(
                '[data-nibbi-panel="' +
                target +
                '"]'
              );


            var showcaseTarget =
              mega.querySelector(
                '[data-nibbi-showcase="' +
                target +
                '"]'
              );


            if(subTarget){

              subTarget
                .classList
                .add(
                  'is-active'
                );

            }


            if(showcaseTarget){

              showcaseTarget
                .classList
                .add(
                  'is-active'
                );

            }

          }



          /* =================================================
             IMPORTANT:
             HOVER changes panel.
             CLICK remains normal link navigation.
          ================================================= */

          mainLinks.forEach(
            function(link){


              link.addEventListener(
                'mouseenter',
                function(){

                  activateCategory(
                    link
                  );

                }
              );


              link.addEventListener(
                'focus',
                function(){

                  activateCategory(
                    link
                  );

                }
              );


            }
          );



          /* =================================================
             OPEN / CLOSE WHOLE MEGA MENU
          ================================================= */

          var headerMenu =
            mega.closest(
              'header-menu'
            );


          if(!headerMenu) return;


          var closeTimer = null;



          headerMenu.addEventListener(
            'mouseenter',
            function(){

              clearTimeout(
                closeTimer
              );


              mega.setAttribute(
                'open',
                ''
              );


              var content =
                mega.querySelector(
                  '.mega-menu__content'
                );


              if(content){

                content.style.removeProperty(
                  'height'
                );

                content.style.removeProperty(
                  'max-height'
                );

                content.style.removeProperty(
                  'overflow'
                );

              }

            }
          );



          headerMenu.addEventListener(
            'mouseleave',
            function(){

              closeTimer =
                setTimeout(
                  function(){

                    mega.removeAttribute(
                      'open'
                    );

                  },
                  170
                );

            }
          );


        }
      );


  }
);
  } catch(e) { console.error(e); }
})();

})();
